module.exports = __webpack_public_path__ + "static/media/collection_page_top_banner_img.9b17edea.png";